import React from "react";

// Styles
import * as S from "./styles";

// Components
import KogModalFadeComponent from "@/main/components/modal/ModalFadeComponent";
import StarRatingVote from "@/main/components/shared/starRating/starRatingVote";
import SecondaryButton from "@/main/components/shared/button/secondaryButton";

// Utils
import { getTranslateByKey, isNullUndefined } from "@/main/services/utils";
import { EvaluationCompanyBuyerResponse } from "@/main/models/response/evaluationSupplierResponse";

interface IModalViewEvaluationSupplierProps {
	isOpenModal: boolean;
	setIsOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
	closeModal: () => void;
	data: EvaluationCompanyBuyerResponse | null;
	isUserSupplier: boolean;
}

function ModalViewEvaluationSupplier({ closeModal, data, isUserSupplier }: IModalViewEvaluationSupplierProps) {
	// Constants
	const PREFIX_ID_ELEMENTS_MODAL = "id-modalViewEvaluationSupplier-";

	if (isNullUndefined(data)) {
		return <div></div>;
	}

	// Functions
	function renderTitleModal() {
		if (isUserSupplier) {
			const evaluateScoreReceived =
				!isNullUndefined(data) && !isNullUndefined(data.evaluationScore) ? String(data.evaluationScore) : "0";
			return getTranslateByKey("information.supplierEvaluationViewTitle1").replace("{0}", evaluateScoreReceived);
		}

		return getTranslateByKey("information.supplierEvaluationViewTitle2");
	}

	return (
		<S.ContainerModal>
			<h6>{renderTitleModal()}</h6>
			<S.ContainerContentView>
				<div className="d-flex flex-column align-items-center">
					<StarRatingVote readonly={true} onChangeRating={() => {}} size={38} rating={data.evaluationScore} />
				</div>

				{!isNullUndefined(data.evaluationDescription) && data.evaluationDescription !== "" && (
					<S.ContainerTextDescription>
						<S.TextDescription>{getTranslateByKey("information.supplierEvaluationViewMessage1")}</S.TextDescription>
						<S.TextAreaReadonly>{data.evaluationDescription}</S.TextAreaReadonly>
					</S.ContainerTextDescription>
				)}
			</S.ContainerContentView>
			<S.AreaButtons>
				<SecondaryButton type="submit" id={`${PREFIX_ID_ELEMENTS_MODAL}btn-close-view-evaluation`} onClick={closeModal}>
					{getTranslateByKey("information.close")}
				</SecondaryButton>
			</S.AreaButtons>
		</S.ContainerModal>
	);
}

function WrapperModalViewEvaluationSupplier(props: IModalViewEvaluationSupplierProps) {
	return (
		<KogModalFadeComponent open={props.isOpenModal} setOpen={props.setIsOpenModal}>
			<ModalViewEvaluationSupplier {...props} />
		</KogModalFadeComponent>
	);
}

export default WrapperModalViewEvaluationSupplier;
